/* Reffiné — preenche estrelas nos cards a partir do endpoint público de estatísticas
   do widget BK Reviews (o app não sincroniza um metafield do Shopify hoje, então isso
   é o único jeito de mostrar a nota real nos cards). Endpoint descoberto no bundle
   público do próprio widget do app; não é documentado oficialmente e pode mudar sem
   aviso — se parar de responder, os cards simplesmente continuam sem estrela. */
(function () {
  var STATS_URL = 'https://bk-reviews-shopify-backend-production.up.railway.app/reviews/';
  var BATCH_SIZE = 60;
  var storeId = (document.currentScript && document.currentScript.dataset.storeId) || '';

  var STAR_PATH = 'M12 3.2l2.6 5.3 5.8.8-4.2 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8L3.4 9.3l5.8-.8L12 3.2Z';

  function starSvg(filled) {
    return '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      '<path d="' + STAR_PATH + '" fill="' + (filled ? 'currentColor' : 'none') + '" ' +
      'stroke="' + (filled ? 'none' : 'currentColor') + '"/></svg>';
  }

  function starsHtml(rating, scaleMax) {
    var full = Math.floor(rating);
    var decimal = rating % 1;
    var half = false;
    if (decimal >= 0.75) { full += 1; }
    else if (decimal >= 0.25) { half = true; }
    var empty = scaleMax - full - (half ? 1 : 0);
    var html = '';
    for (var i = 0; i < full; i++) { html += starSvg(true); }
    if (half) { html += '<span class="rf-star--half">' + starSvg(false) + starSvg(true) + '</span>'; }
    for (var j = 0; j < empty; j++) { html += starSvg(false); }
    return html;
  }

  function renderInto(card, rating, count) {
    if (card.querySelector('.rf-card__rate')) { return; }
    var name = card.querySelector('.rf-card__name');
    if (!name) { return; }
    var wrap = document.createElement('div');
    wrap.className = 'rf-card__rate';
    wrap.innerHTML =
      '<span class="rf-stars" aria-label="' + rating + ' de 5">' + starsHtml(rating, 5) + '</span>' +
      '<span>' + rating.toFixed(1) + ' (' + count + ')</span>';
    name.insertAdjacentElement('afterend', wrap);
  }

  function fetchBatch(ids, cardsById) {
    var url = STATS_URL + encodeURIComponent(storeId) + '/metadata/collection/?product_ids=' + ids.join(',');
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : []; })
      .then(function (list) {
        (list || []).forEach(function (item) {
          if (!item || !item.qty_general_rating) { return; }
          var cards = cardsById[item.product_id];
          if (!cards) { return; }
          cards.forEach(function (card) {
            renderInto(card, item.average_rating, item.qty_general_rating);
          });
        });
      })
      .catch(function () {});
  }

  function run() {
    if (!storeId) { return; }
    var cardsById = {};
    document.querySelectorAll('.rf-card[data-product-id]').forEach(function (card) {
      if (card.querySelector('.rf-card__rate')) { return; }
      var id = card.getAttribute('data-product-id');
      if (!id) { return; }
      (cardsById[id] = cardsById[id] || []).push(card);
    });
    var ids = Object.keys(cardsById);
    for (var i = 0; i < ids.length; i += BATCH_SIZE) {
      fetchBatch(ids.slice(i, i + BATCH_SIZE), cardsById);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
